// Vendor
import { ComponentFactoryResolver, Type } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ConfigModule } from 'NewAngular/config/config.module';
import { NavigationModule } from 'NewAngular/features/components/navigation/navigation.module';
import { StoreModule } from '@ngrx/store';
import { getLogger } from 'NewAngular/state/logger';
import { CommonModule, DOCUMENT } from '@angular/common';
import { FormsModule } from '@angular/forms';
// Base classes
import { DoVariableBootstrap } from 'SecuritiesApp/ts/extendable-classes/do-variable-bootstrap';
// Modules
import { ComparablesModalButtonModule } from 'SecuritiesApp/ts/features/comparables-modal-button/comparables-modal-button.module';
import { GeneralChartModule } from 'ChartApp/ts/features/general-chart/general-chart.module';
import { HelpModalModule } from 'NewAngular/features/components/modals/help-modal/help-modal.module';
import { IconWrapperModule } from 'NewAngular/features/components/icon-wrapper/icon-wrapper.module';
import { KeyStatsModalModule } from 'CalculationsApp/ts/features/key-stats-modal/key-stats-modal.module';
import { PerformanceIncludeBenchmarkCheckboxModule } from 'SecuritiesApp/ts/features/performance-include-benchmark-checkbox/performance-include-benchmark-checkbox.module';
import { PieChartModule } from 'ChartApp/ts/features/pie-chart/pie-chart.module';
import { SideMenuModule } from 'NewAngular/features/components/side-menu/side-menu.module';
import { RiskInfoCheckboxesModule } from 'SecuritiesApp/ts/features/risk-info-checkboxes/risk-info-checkboxes.module';
import { RiskInfoScatterPlotModule } from 'SecuritiesApp/ts/features/risk-info-scatter-plot/risk-info-scatter-plot.module';
import { RiskLookbackModule } from 'SecuritiesApp/ts/features/risk-lookback/risk-lookback.module';
import { SecurityHeaderControlModule } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.module';
import { SingleSeriesFundChartModule } from 'ChartApp/ts/features/single-series-fund-chart/single-series-fund-chart.module';
import { TopPortfolioHoldingsModule } from 'SecuritiesApp/ts/features/top-portfolio-holdings/top-portfolio-holdings.module';
// Components
import { ComparablesModalButtonComponent } from 'SecuritiesApp/ts/features/comparables-modal-button/comparables-modal-button.component';
import { GeneralChartComponent } from 'ChartApp/ts/features/general-chart/components/general-chart/general-chart.component';
import { GeneralChartResponsiveComponent } from 'ChartApp/ts/features/general-chart/components/general-chart-responsive/general-chart-responsive.component';
import { HelpModalWithTriggerComponent } from 'NewAngular/features/components/modals/help-modal/components/help-modal-with-trigger.component';
import { IconWrapperComponent } from 'NewAngular/features/components/icon-wrapper/icon-wrapper.component';
import { KeyStatsModalComponent } from 'CalculationsApp/ts/features/key-stats-modal/components/key-stats-modal/key-stats-modal.component';
import { PerformanceIncludeBenchmarkCheckboxComponent } from 'SecuritiesApp/ts/features/performance-include-benchmark-checkbox/performance-include-benchmark-checkbox';
import { PieChartComponent } from 'ChartApp/ts/features/pie-chart/pie-chart.component';
import { SideMenuComponent } from 'NewAngular/features/components/side-menu/side-menu.component';
import { RiskLookbackComponent } from 'SecuritiesApp/ts/features/risk-lookback/risk-lookback.component';
import { SingleSeriesFundChartComponent } from 'ChartApp/ts/features/single-series-fund-chart/single-series-fund-chart.component';
import { TopBarNavComponent } from 'NewAngular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { TopPortfolioHoldingsComponent } from 'SecuritiesApp/ts/features/top-portfolio-holdings/top-portfolio-holdings.component';
import { RiskInfoScatterPlotComponent } from 'SecuritiesApp/ts/features/risk-info-scatter-plot/risk-info-scatter-plot.component';
import { RiskInfoCheckboxesComponent } from 'SecuritiesApp/ts/features/risk-info-checkboxes/risk-info-checkboxes.component';
import { SecurityHeaderControlComponent } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.component';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
const entryComponents = [
    PerformanceIncludeBenchmarkCheckboxComponent,
    ComparablesModalButtonComponent,
    GeneralChartResponsiveComponent,
    GeneralChartComponent,
    IconWrapperComponent,
    HelpModalWithTriggerComponent,
    KeyStatsModalComponent,
    PieChartComponent,
    RiskInfoCheckboxesComponent,
    RiskInfoScatterPlotComponent,
    RiskLookbackComponent,
    SecurityHeaderControlComponent,
    SingleSeriesFundChartComponent,
    SideMenuComponent,
    TopBarNavComponent,
    TopPortfolioHoldingsComponent,
];
export class CompanyFundsQuoteBetaModule extends DoVariableBootstrap {
    constructor(_document, componentFactoryResolver) {
        super(_document, componentFactoryResolver, entryComponents);
        this.nonSingularComponents = [
            ComparablesModalButtonComponent,
            HelpModalWithTriggerComponent,
            PieChartComponent,
            GeneralChartComponent,
            IconWrapperComponent,
            RiskInfoCheckboxesComponent,
            RiskInfoScatterPlotComponent,
            RiskLookbackComponent,
            SecurityHeaderControlComponent,
            SingleSeriesFundChartComponent,
            TopBarNavComponent,
            TopPortfolioHoldingsComponent,
        ];
    }
}
CompanyFundsQuoteBetaModule.ɵfac = function CompanyFundsQuoteBetaModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CompanyFundsQuoteBetaModule)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i0.ComponentFactoryResolver)); };
CompanyFundsQuoteBetaModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: CompanyFundsQuoteBetaModule });
CompanyFundsQuoteBetaModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule,
        ComparablesModalButtonModule,
        FormsModule,
        ConfigModule,
        CommonModule,
        GeneralChartModule,
        IconWrapperModule,
        HelpModalModule,
        KeyStatsModalModule,
        NavigationModule,
        PerformanceIncludeBenchmarkCheckboxModule,
        PieChartModule,
        RiskInfoCheckboxesModule,
        SideMenuModule,
        RiskInfoScatterPlotModule,
        RiskLookbackModule,
        SecurityHeaderControlModule,
        SingleSeriesFundChartModule,
        StoreModule.forRoot({}, { metaReducers: getLogger() }),
        TopPortfolioHoldingsModule] });
